import background_texture from "./background_texture.jpg";
import splatter_layer from "./splatter_layer.png";
import splatter_hard_1 from "./splatter_hard_1.png";
import splatter_hard_2 from "./splatter_hard_2.png";
import splatter_hard_3 from "./splatter_hard_3.png";
import splatter_soft_1 from "./splatter_soft_1.png";
import splatter_soft_2 from "./splatter_soft_2.png";
import splatter_soft_3 from "./splatter_soft_3.png";

// Fixed art direction only. Editable home content images (section overlays,
// project tiles, leader headshots) are no longer bundled here — they are served
// from the home content document (static defaults under /images/home/, or
// officer-uploaded images via /api/files). See home_content.default.json.
export var Images = {
  background_texture: background_texture,
  splatter_layer: splatter_layer,
  splatter_hard_1: splatter_hard_1,
  splatter_hard_2: splatter_hard_2,
  splatter_hard_3: splatter_hard_3,
  splatter_soft_1: splatter_soft_1,
  splatter_soft_2: splatter_soft_2,
  splatter_soft_3: splatter_soft_3,
};
